import * as types from './actionTypes';

export const getFile = () => {
  return {
    type: types.GET_FILES_REQUEST
  }
};
export const getFileSuccess = (data) => {
  return {
    type: types.GET_FILES_SUCCESS,
    payLoad: data,
  };
};
export const getFileFailure = () => {
  return {
    type: types.GET_FILES_FAILURE
  };
};